var render = function (_h,_vm) {var _c=_vm._c;return _c('h2',{class:['section__title', { '-align-left': _vm.props.alignLeft, '-flat': _vm.props.flat }]},[_c('span',{staticClass:"section__title-underline"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }